const queryBrandsList = `
query GetBrands {
    ambrandlist(imageWidth: 1, imageHeight: 1, showCount: true, displayZero: true) {
      all_letters
      brand_attribute {
        attribute_code
        attribute_type
        entity_type
        input_type
      }
      display_zero
      filter_display_all
      image_height
      image_width
      items {
        brandId
        label
        letter
        cnt
        description
        short_description
        url
      }
      show_count
      show_filter
      show_images
      show_search
    }
  }
`;

export { queryBrandsList };
